// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `span.label-tag {
  background-color: var(--red);
  color: #ffffff;
  border-radius: 3px;
  padding: 3px 6px;
  display: inline-block;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 0.6em;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./wp_components/core/Label/index.less"],"names":[],"mappings":"AACA;EACI,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;ACAJ;AACA,oCAAoC","sourcesContent":["@import (reference) \"../../../less/variables.less\";\nspan.label-tag {\n    background-color: var(--red);\n    color: @white;\n    border-radius: 3px;\n    padding: 3px 6px;\n    display: inline-block;\n    font-weight: bold;\n    text-transform: uppercase;\n    font-size: 0.6em;\n}","span.label-tag {\n  background-color: var(--red);\n  color: #ffffff;\n  border-radius: 3px;\n  padding: 3px 6px;\n  display: inline-block;\n  font-weight: bold;\n  text-transform: uppercase;\n  font-size: 0.6em;\n}\n/*# sourceMappingURL=index.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
